import { IServices } from "@netent/origin";
import { PlayUIListenerCreator } from "../../types";

export const onPluginRequest: PlayUIListenerCreator = (
  services: IServices
) => () => {
  if (services.pluginMenu.isOpen()) {
    services.pluginMenu.close();
  } else {
    services.pluginMenu.open();
  }
};
